// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ebook-viewer {
  overflow-y: scroll;
  z-index: 5;
}
.viewer {
  height: 100%;
}
.view-area {
  height: 100%;
  touch-action: none;
  position: relative;
}

@keyframes fade-right {
  0% {
    transform: translateX(200px);
    opacity: 0;
  }
  100% {
    transform: translateX(0px);
    opacity: 1;
  }
}

@keyframes fade-left {
  0% {
    transform: translateX(-200px);
    opacity: 0;
  }
  100% {
    transform: translateX(0px);
    opacity: 1;
  }
}

@keyframes fade-down {
  0% {
    transform: translateY(-60px);
    opacity: 0;
  }
  100% {
    transform: translateX(0px);
    opacity: 1;
  }
}

@keyframes fade-up {
  0% {
    transform: translateY(60px);
    opacity: 0;
  }
  100% {
    transform: translateX(0px);
    opacity: 1;
  }
}
.panel-icon {
  color: white;
  font-size: 18px;
  opacity: 0.9;
}
.left-panel {
  width: 40px;
  height: 60%;
  position: absolute;
  left: 0px;
  top: calc(50vh - 30%);
  background-color: rgba(75, 75, 75, 0.3);
  border-bottom-right-radius: 20px;
  border-top-right-radius: 20px;
  z-index: 10;
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.right-panel {
  width: 40px;
  height: 60%;
  position: absolute;
  right: 0px;
  top: calc(50vh - 30%);
  background-color: rgba(75, 75, 75, 0.3);
  border-bottom-left-radius: 20px;
  border-top-left-radius: 20px;
  z-index: 10;
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.top-panel {
  width: 60%;
  height: 40px;
  position: absolute;
  left: calc(50vw - 30%);
  top: 0px;
  background-color: rgba(75, 75, 75, 0.3);
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  z-index: 10;
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.bottom-panel {
  width: 60%;
  height: 40px;
  position: absolute;
  left: calc(50vw - 30%);
  bottom: 0px;
  background-color: rgba(75, 75, 75, 0.3);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  z-index: 10;
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.operation-panel-container {
  width: 450px;
  height: 60px;
  position: absolute;
  top: 0px;
  left: calc(50vw - 225px);
  z-index: 15;

  transition: transform 0.5s ease;
}
.progress-panel-container {
  width: 450px;
  height: 60px;
  position: absolute;
  top: calc(100vh - 60px);
  left: calc(50vw - 225px);
  z-index: 15;
  transition: transform 0.5s ease;
}
.setting-panel-container {
  width: 299px;
  height: 100vh;
  position: absolute;
  top: 0px;
  right: 0px;
  transition: transform 0.5s ease;
  z-index: 15;
}
.navigation-panel-container {
  width: 299px;
  height: 100vh;
  position: absolute;
  top: 0px;
  left: 0px;
  transition: transform 0.5s ease;
  z-index: 15;
}
.view-area-page {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 28px;
  bottom: 25px;
  /* width: calc(100% - 100px);
  height: calc(100% - 100px); */
  z-index: 5;
  -webkit-user-select: text;
          user-select: text;
}
.previous-chapter-single-container {
  width: 40px !important;
  height: 40px !important;
  border-radius: 50%;
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 30px;
  transform: rotate(90deg);
  cursor: pointer;
  opacity: 0.2;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.next-chapter-single-container {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transform: rotate(-90deg);
  cursor: pointer;
  opacity: 0.2;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}
.next-chapter-single-container:hover {
  opacity: 0.7;
}
.previous-chapter-single-container:hover {
  opacity: 0.5;
}
.previous-chapter-single {
  height: 20px;
  font-size: 20px;
}
.next-chapter-single {
  font-size: 20px;
  height: 20px;
}
.reader-setting-icon {
  margin: 8px;
  opacity: 0.7;
  width: 50px;
  padding: 15px;
}
.scale-container {
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.text-to-speech-icon {
  font-size: 22px;
  margin-right: 10px;
}
.reader-setting-icon-container,
.reader-zoom-in-icon-container {
  width: 50px;
  height: 50px;
  font-size: 20px;
  cursor: pointer;
  z-index: 10;
  transition: 0.1s;
  line-height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0, 2s;
  float: right;
}
.reader-setting-icon-container:hover,
.reader-zoom-in-icon-container:hover {
  border-radius: 50%;
}
.reader-zoom-in-icon-container {
  font-size: 23px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/reader/index.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;AACA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,uCAAuC;EACvC,gCAAgC;EAChC,6BAA6B;EAC7B,WAAW;EACX,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,uCAAuC;EACvC,+BAA+B;EAC/B,gCAAgC;EAChC,WAAW;EACX,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,uCAAuC;EACvC,4BAA4B;EAC5B,6BAA6B;EAC7B,WAAW;EACX,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,WAAW;;EAEX,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;EACX,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,+BAA+B;EAC/B,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,SAAS;EACT,YAAY;EACZ;+BAC6B;EAC7B,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB","sourcesContent":[".ebook-viewer {\n  overflow-y: scroll;\n  z-index: 5;\n}\n.viewer {\n  height: 100%;\n}\n.view-area {\n  height: 100%;\n  touch-action: none;\n  position: relative;\n}\n\n@keyframes fade-right {\n  0% {\n    transform: translateX(200px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0px);\n    opacity: 1;\n  }\n}\n\n@keyframes fade-left {\n  0% {\n    transform: translateX(-200px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0px);\n    opacity: 1;\n  }\n}\n\n@keyframes fade-down {\n  0% {\n    transform: translateY(-60px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0px);\n    opacity: 1;\n  }\n}\n\n@keyframes fade-up {\n  0% {\n    transform: translateY(60px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0px);\n    opacity: 1;\n  }\n}\n.panel-icon {\n  color: white;\n  font-size: 18px;\n  opacity: 0.9;\n}\n.left-panel {\n  width: 40px;\n  height: 60%;\n  position: absolute;\n  left: 0px;\n  top: calc(50vh - 30%);\n  background-color: rgba(75, 75, 75, 0.3);\n  border-bottom-right-radius: 20px;\n  border-top-right-radius: 20px;\n  z-index: 10;\n  opacity: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.right-panel {\n  width: 40px;\n  height: 60%;\n  position: absolute;\n  right: 0px;\n  top: calc(50vh - 30%);\n  background-color: rgba(75, 75, 75, 0.3);\n  border-bottom-left-radius: 20px;\n  border-top-left-radius: 20px;\n  z-index: 10;\n  opacity: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.top-panel {\n  width: 60%;\n  height: 40px;\n  position: absolute;\n  left: calc(50vw - 30%);\n  top: 0px;\n  background-color: rgba(75, 75, 75, 0.3);\n  border-bottom-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n  z-index: 10;\n  opacity: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.bottom-panel {\n  width: 60%;\n  height: 40px;\n  position: absolute;\n  left: calc(50vw - 30%);\n  bottom: 0px;\n  background-color: rgba(75, 75, 75, 0.3);\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  z-index: 10;\n  opacity: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.operation-panel-container {\n  width: 450px;\n  height: 60px;\n  position: absolute;\n  top: 0px;\n  left: calc(50vw - 225px);\n  z-index: 15;\n\n  transition: transform 0.5s ease;\n}\n.progress-panel-container {\n  width: 450px;\n  height: 60px;\n  position: absolute;\n  top: calc(100vh - 60px);\n  left: calc(50vw - 225px);\n  z-index: 15;\n  transition: transform 0.5s ease;\n}\n.setting-panel-container {\n  width: 299px;\n  height: 100vh;\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  transition: transform 0.5s ease;\n  z-index: 15;\n}\n.navigation-panel-container {\n  width: 299px;\n  height: 100vh;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  transition: transform 0.5s ease;\n  z-index: 15;\n}\n.view-area-page {\n  position: absolute;\n  left: 0px;\n  right: 0px;\n  top: 28px;\n  bottom: 25px;\n  /* width: calc(100% - 100px);\n  height: calc(100% - 100px); */\n  z-index: 5;\n  user-select: text;\n}\n.previous-chapter-single-container {\n  width: 40px !important;\n  height: 40px !important;\n  border-radius: 50%;\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  font-size: 30px;\n  transform: rotate(90deg);\n  cursor: pointer;\n  opacity: 0.2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n}\n.next-chapter-single-container {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  transform: rotate(-90deg);\n  cursor: pointer;\n  opacity: 0.2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n}\n.next-chapter-single-container:hover {\n  opacity: 0.7;\n}\n.previous-chapter-single-container:hover {\n  opacity: 0.5;\n}\n.previous-chapter-single {\n  height: 20px;\n  font-size: 20px;\n}\n.next-chapter-single {\n  font-size: 20px;\n  height: 20px;\n}\n.reader-setting-icon {\n  margin: 8px;\n  opacity: 0.7;\n  width: 50px;\n  padding: 15px;\n}\n.scale-container {\n  min-width: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.text-to-speech-icon {\n  font-size: 22px;\n  margin-right: 10px;\n}\n.reader-setting-icon-container,\n.reader-zoom-in-icon-container {\n  width: 50px;\n  height: 50px;\n  font-size: 20px;\n  cursor: pointer;\n  z-index: 10;\n  transition: 0.1s;\n  line-height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: 0, 2s;\n  float: right;\n}\n.reader-setting-icon-container:hover,\n.reader-zoom-in-icon-container:hover {\n  border-radius: 50%;\n}\n.reader-zoom-in-icon-container {\n  font-size: 23px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
